/**
 * All constants that are specific to `pushEventModule`
 *
 * This is here because there might be quite a few constants, and the idea is to not make the .js file super long with
 * 50 lines of just constants
 *
 * See https://confluence.nml.com/display/CPGT/Component+Library+Inventory for reference
 */
// The action names used in the datalayer call, as referenced on the Confluence page
var MODULE_ACTIONS = {
  AUDIO_PLAY: 'audio-play',
  CONTENT_EXPAND: 'content-expand',
  EMAIL_COLLECTION: 'email-collection',
  IN_PAGE_NAVIGATION: 'in-page-navigation',
  MODULE_SCROLL: 'module-scroll',
  SOCIAL_SHARE: 'social-share',
  VIDEO_PLAY: 'video-play'
};
export { MODULE_ACTIONS };